import { render, staticRenderFns } from "./AdministratorList.vue?vue&type=template&id=e455bfe8"
import script from "./AdministratorList.vue?vue&type=script&lang=ts"
export * from "./AdministratorList.vue?vue&type=script&lang=ts"
import style0 from "./AdministratorList.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports